<template>
  <div class="container index_bg">
    <scale-box>
      <el-container class="main-wrapper">
        <el-header>
          <div class="new-time">
            <img
              class="img-icon"
              :src="require('../../assets/img/im_left.png')"
            />
            <span class="time-text">{{ newTime }}</span>
            <img
              class="img-icon"
              :src="require('../../assets/img/im_right.png')"
            />
          </div>
        </el-header>
        <el-main>
          <el-row type="flex" :gutter="15" class="row-bg" justify="space-around">
            <el-col :span="7">
              <div class="grid-content1">
                <div v-if="tableSignedData.length == 0" class="no-data">
                  <img
                    class="img-no-data"
                    :src="require('../../assets/img/img-no-data.png')"
                  />
                  <span>暂无数据</span>
                </div>
                <el-table
                  v-else
                  :data="tableSignedData"
                  :header-cell-style="{
                    backgroundColor: 'rgba(20, 55, 120, 0.8)',
                    color: '#71CDF9',
                    fontSize: '18px',
                    textAlign: 'center',
                  }"
                  :cell-style="{
                    backgroundColor: 'transparent',
                    fontSize: '16px',
                    borderColor: 'rgba(113, 205, 249, 0.1)',
                    textAlign: 'center',
                  }"
                  :row-class-name="tableRowClassNameSign"
                  class="el-table"
                  ref="tableSign"
                >
                  <el-table-column prop="num" label="序号" min-width="17%">
                  </el-table-column>
                  <el-table-column
                    prop="plateNumber"
                    label="主车号"
                    min-width="28%"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="driverName"
                    label="车主"
                    min-width="22%"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    class-name="tableColumnClassName"
                    min-width="33%"
                  >
                    <template slot-scope="scope">
                      <div class="state-box1" v-if="scope.row.status == 16">
                        已登记
                      </div>
                      <div class="state-box" v-else-if="scope.row.status == 15">
                        未登记
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col :span="10">
              <el-row class="grid-content2">
                <div
                  v-if="tableEntranceData.length == 0"
                  class="no-data-center"
                >
                  <img
                    class="img-no-data"
                    :src="require('../../assets/img/img-no-data.png')"
                  />
                  <span>暂无数据</span>
                </div>
                <div v-else>
                  <el-table
                    :data="tableEntranceData"
                    :header-cell-style="{
                      backgroundColor: 'rgba(20, 55, 120, 0.8)',
                      color: '#71CDF9',
                      fontSize: '18px',
                      textAlign: 'center',
                    }"
                    :cell-style="{
                      backgroundColor: 'transparent',
                      fontSize: '16px',
                      borderColor: 'rgba(113, 205, 249, 0.1)',
                      color: '#fff',
                      textAlign: 'center',
                    }"
                    :row-class-name="tableRowClassName"
                    class="el-table"
                    ref="tableEntrance"
                  >
                    <el-table-column prop="num" label="序号" min-width="33%">
                    </el-table-column>
                    <el-table-column
                      prop="plateNumber"
                      label="主车号"
                      min-width="34%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="driverName"
                      label="车主"
                      min-width="33%"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </el-row>
              <el-row class="grid-content3">
                <div
                  v-if="tableSecurityCheckData.length == 0"
                  class="no-data-center"
                >
                  <img
                    class="img-no-data"
                    :src="require('../../assets/img/img-no-data.png')"
                  />
                  <span>暂无数据</span>
                </div>
                <div v-else>
                  <el-table
                    :data="tableSecurityCheckData"
                    :header-cell-style="{
                      backgroundColor: 'rgba(20, 55, 120, 0.8)',
                      color: '#71CDF9',
                      fontSize: '18px',
                      textAlign: 'center',
                    }"
                    :cell-style="{
                      backgroundColor: 'transparent',
                      fontSize: '16px',
                      color: '#fff',
                      borderColor: 'rgba(113, 205, 249, 0.1)',
                    }"
                    :row-style="{ height: '60px' }"
                    :row-class-name="tableRowClassName"
                    class="el-table"
                  >
                    <el-table-column
                      prop="num"
                      align="center"
                      label="序号"
                      min-width="33%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="plateNumber"
                      align="center"
                      label="主车号"
                      min-width="34%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="driverName"
                      align="center"
                      label="车主"
                      min-width="33%"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </el-row>
            </el-col>
            <el-col :span="7">
              <div class="grid-content4">
                <div v-if="tablePlanData.length == 0" class="no-data">
                  <img
                    class="img-no-data"
                    :src="require('../../assets/img/img-no-data.png')"
                  />
                  <span>暂无数据</span>
                </div>
                <el-table
                  v-else
                  :data="tablePlanData"
                  :header-cell-style="{
                    backgroundColor: 'rgba(20, 55, 120, 0.8)',
                    color: '#71CDF9',
                    fontSize: '18px',
                    textAlign: 'center',
                  }"
                  :cell-style="{
                    backgroundColor: 'transparent',
                    fontSize: '16px',
                    borderColor: 'rgba(113, 205, 249, 0.1)',
                    color: '#fff',
                    textAlign: 'center',
                  }"
                  :row-class-name="tableRowClassName"
                  class="el-table"
                  ref="tablePlan"
                >
                  <el-table-column prop="num" label="序号" min-width="33%">
                  </el-table-column>
                  <el-table-column
                    prop="plateNumber"
                    label="主车号"
                    min-width="34%"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="driverName"
                    label="车主"
                    min-width="33%"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </scale-box>
  </div>
</template>

<script>
import request from "@/utils/request";
import ScaleBox from "@/components/SacleBox/index.vue";
const synth = window.speechSynthesis;
const msg = new SpeechSynthesisUtterance();
export default {
  name: "screen-display",
  components: {
    ScaleBox,
  },
  data() {
    return {
      newTime: "",
      timer: null, //定时器名称
      tableSignedData: [],
      tableEntranceData: [],
      tableSecurityCheckData: [],
      tablePlanData: [],
      // 3. 本地取出缓存list
      tableOldSecurityCheckData:
        JSON.parse(localStorage.getItem("newList")) || [],
    };
  },
  // 目标: 侦听list改变 - 同步到本地localStorage里
  // 1. 侦听器-list
  created() {
    this.getOrderData();
  },
  mounted() {
    // 1.设置表格数据自动滚动
    if (this.tableSignedData.length != 0) {
      const table = this.$refs.tableSign;
      const divData = table.bodyWrapper; // 拿到表格中承载数据的div元素
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      setInterval(() => {
        divData.scrollTop += 1; // 元素自增距离顶部1像素
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop === divData.scrollHeight) {
          divData.scrollTop = 0; // 重置table距离顶部距离
        }
      }, 100);
    }

    if (this.tableEntranceData.length != 0) {
      const table = this.$refs.tableEntrance;
      const divData = table.bodyWrapper;
      setInterval(() => {
        divData.scrollTop += 1;
        if (divData.clientHeight + divData.scrollTop === divData.scrollHeight) {
          divData.scrollTop = 0;
        }
      }, 100);
    }

    if (this.tablePlanData.length != 0) {
      const table = this.$refs.tablePlan;
      const divData = table.bodyWrapper;
      setInterval(() => {
        divData.scrollTop += 1;
        if (divData.clientHeight + divData.scrollTop === divData.scrollHeight) {
          divData.scrollTop = 0;
        }
      }, 100);
    }

    // 2.每隔一秒钟刷新当前页面（包括清除定时器）
    this.getTime();
    const timer = setInterval(() => {
      this.getTime();
    }, 1000);
    const getData = setInterval(() => {
      this.getOrderData();
    }, 300000);
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer, getData);
    });
  },
  watch: {
    tableOldSecurityCheckData: {
      handler() {
        // 2. 存入本地
        localStorage.setItem(
          "newList",
          JSON.stringify(this.tableSecurityCheckData)
        );
      },
      deep: true,
    },
  },
  methods: {
    // 表格隔行变色
    tableRowClassNameSign({ row, rowIndex }) {
      if (rowIndex % 2 != 0) {
        if (row.status === 16) {
          return "success-row warning-row"; //这是类名
        } else if (row.status === 15) {
          return "success-row warning-row1";
        }
      } else {
        if (row.status === 16) {
          return "warning-row";
        } else if (row.status === 15) {
          return "warning-row1";
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 != 0) {
        return "success-row";
      } else {
        return "";
      }
    },
    // 获取当前时间（时分秒）
    getTime() {
      var nowDate = new Date();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      var newTime =
        hours +
        ":" +
        (minutes >= 10 ? minutes : "0" + minutes) +
        ":" +
        (seconds >= 10 ? seconds : "0" + seconds);
      this.newTime = newTime;
    },
    // 获取已签到车辆
    getOrderData() {
      request
        .get("/free/screen")
        .then((res) => {
          if (res.data) {
            var newLists1 = [];
            res.data.punched.forEach((el, index) => {
              var obj = {
                num: index + 1,
                plateNumber: el.plateNumber,
                driverName: el.driverName,
                status: el.status,
              };
              newLists1.push(obj);
            });
            this.tableSignedData = newLists1;

            var newLists2 = [];
            res.data.securityChecked.forEach((el, index) => {
              var obj = {
                num: index + 1,
                plateNumber: el.plateNumber,
                driverName: el.driverName,
              };
              newLists2.push(obj);
            });
            this.tableEntranceData = newLists2;

            var newLists3 = [];
            res.data.registered.forEach((el, index) => {
              var obj = {
                num: index + 1,
                plateNumber: el.plateNumber,
                driverName: el.driverName,
              };
              newLists3.push(obj);
            });
            this.tableSecurityCheckData = newLists3;

            var newLists4 = [];
            res.data.effected.forEach((el, index) => {
              var obj = {
                num: index + 1,
                plateNumber: el.plateNumber,
                driverName: el.driverName,
              };
              newLists4.push(obj);
            });
            this.tablePlanData = newLists4;
            // 执行语音播报
            this.playVoice();
          }
        })
        .catch((err) => {});
    },
    // 语音播报
    playVoice() {
      var newLists = [];
      this.tableSecurityCheckData.forEach((el, index) => {
        this.tableOldSecurityCheckData.forEach((e2, index2) => {
          if (
            el.plateNumber != e2.plateNumber &&
            el.driverName != e2.driverName
          ) {
            var obj = {
              plateNumber: el.plateNumber
            };
            newLists.push(obj);
          }
        });
      });
      var textShow="";
      textShow=newLists.join(" ");

      this.handleSpeak("请"+textShow+"车辆进行安检"); // 传入需要播放的文字
    },
    // 语音播报的函数
    handleSpeak(text) {
      msg.text = text; // 文字内容
      msg.lang = "zh-CN"; // 使用的语言:中文
      msg.volume = 1; // 声音音量：1
      msg.rate = 1; // 语速：1
      msg.pitch = 1; // 音高：1
      // 增加控制播放次数
      // let count = 1
      // speechSynthesis.speak(speech)
      // while (count < repeatNum) {
      //   speechSynthesis.speak(speech)
      //   count++
      // }
      synth.speak(msg); // 播放
    },
    // 语音停止
    handleStop(e) {
      msg.text = e;
      msg.lang = "zh-CN";
      synth.cancel(msg);
    },
  },
};
</script>

<style  lang="scss">
.main-wrapper {
  user-select: none;
  width: 1920px;
  height: 1080px;
  margin: 0 auto;
  background-image: url("../../assets/img/index-bg1.png");
  // width: 100%;
  // height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
}
.el-table .warning-row {
  color: #30e0b5 !important;
}
.el-table .warning-row1 {
  color: #ffffff !important;
}
.success-row {
  background-color: rgba(113, 205, 249, 0.1) !important;
}
.el-table,
.el-table__expanded-cell {
  background-color: transparent;
}
.el-table th {
  background-color: transparent;
  border-color: rgba(0, 143, 253, 0.4) !important;
}
::v-deep .el-table__header-wrapper {
  border: solid 1px #04c2ed;
  // box-sizing: border-box;
}
.el-table tr {
  background-color: transparent;
  border-color: rgba(0, 143, 253, 0.4) !important;
}
// 滚动条隐藏掉
.el-table--scrollable-y .el-table__body-wrapper {
  overflow: hidden !important;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow: hidden !important;
}
//修改表格的最下方边框
.el-table::before {
  background-color: rgba(113, 205, 249, 0.1) !important;
}
.index_bg {
  // background: url("../../assets/img/index-bg.png") no-repeat;
  // width: 100%;
  // height: 100%;
  // background-size: 100% 100%;
}

.state-box {
  width: 60%;
  font-size: 13px;
  color: #b1b1b1;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  margin: 0 25%;
}
.state-box1 {
  width: 60%;
  color: #30e0b5;
  font-size: 13px;
  border: 1px solid #30e0b5;
  border-radius: 4px;
  margin: 0 25%;
}
.el-header {
  height: 140px !important;
  line-height: 140px !important;
  padding: 0 2% !important;
}
.el-main {
  height: calc(100% - 120px) !important;
  padding: 0px !important;
}
.new-time {
  display: flex;
  align-items: center;
}
.row-bg {
  height: 100%;
}
.time-text {
  font-size: 48px;
  font-family: DIN;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 2px 2px 5px #24abf8;
}
.img-icon {
  width: 10px;
  height: 20px;
  margin: 6px 5px;
}
.img-no-data {
  width: 182px;
  height: 182px;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-top: 60%;
}
.no-data-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-top: 8%;
}
.grid-content1 {
  padding: 10% 6%;
  border-radius: 4px;
  background: url("../../assets/img/img-bg-four.png") no-repeat;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}
.grid-content2 {
  padding: 6%;
  border-radius: 4px;
  margin-bottom: 2%;
  height: 49%;
  background: url("../../assets/img/img-bg-three.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
}
.grid-content3 {
  padding: 8% 6%;
  border-radius: 4px;
  height: 49%;
  background: url("../../assets/img/im_bg-two.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
}
.grid-content4 {
  padding: 10% 6%;
  border-radius: 4px;
  height: 100%;
  background: url("../../assets/img/im-bg-one.png") no-repeat;
  background-size: 100% 100%;
}
.el-col-7 {
    width: 27.1666666667% !important;
}
.el-col-10 {
    width: 45.6666666666% !important;
}
</style>
